/** Festliche Header-Dekoration (Dezember / Dev-Simulation) – rein visuell. */
export function ChristmasHeaderDecor() {
  return (
    <div className="eh-xmas-header-decor pointer-events-none absolute inset-0 z-[1] overflow-hidden" aria-hidden="true">
      <div className="eh-xmas-header-decor__glow" />
      <div className="eh-xmas-header-decor__garland" />
      <div className="eh-xmas-header-decor__ornament eh-xmas-header-decor__ornament--left" />
      <div className="eh-xmas-header-decor__ornament eh-xmas-header-decor__ornament--right" />
    </div>
  );
}

export function ChristmasNavLights() {
  return (
    <div className="eh-xmas-nav-lights pointer-events-none absolute inset-x-0 top-0 z-[1] h-3 -translate-y-1/2" aria-hidden="true">
      {Array.from({ length: 28 }, (_, i) => (
        <span
          key={i}
          className="eh-xmas-nav-lights__bulb"
          style={{ animationDelay: `${(i % 7) * 0.35}s` }}
        />
      ))}
    </div>
  );
}
